import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Slider from "react-slick"

const NewsSlider = () => {
  const { allStrapiArticle } = useStaticQuery(graphql`
    {
      allStrapiArticle(filter: { isFeatured: { eq: true } }, limit: 4) {
        nodes {
          id
          slug
          title
          description
          subtitle
          date
          cover {
            alternativeText
            localFile {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED)
              }
            }
          }
        }
      }
      allStrapiCategory(
        filter: { articles: { elemMatch: { isFeatured: { eq: true } } } }
      ) {
        nodes {
          slug
          name
        }
      }
    }
  `)

  var options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  }

  const settings = {
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    arrows: false,
    className:"sample",
    // dotsClass: 'button__bar'
  };

  return (
    <>
      <Slider
        {...settings}
      >
        {allStrapiArticle.nodes.map((blog, index) => {
          const pathToImage = getImage(blog.cover.localFile)
          const publishDate = new Date(blog.date)?.toLocaleDateString(
            "es-MX",
            options
          )
          return (
            <div className="hero-container-image" key={index}>
              <GatsbyImage
                image={pathToImage}
                alt={blog.cover.alternativeText}
              />
              <div className="overlay"></div>
              <div className="hero-container-text">
              <Link to={`/blog/${blog.slug}`}>
                <h3>{blog.title}</h3>
              </Link>
                <span>{publishDate}</span>
                <h6>{blog.subtitle}</h6>
                <div className="anchor-container">
                  <Link className="anchor" to={`/blog/${blog.slug}`}>Leer Más</Link>
                </div>
              </div>
            </div>
          )
        })}
      </Slider>
    </>
  )
}

export default NewsSlider
